import React from 'react'
import { useHistory } from 'react-router-dom'
import { gtmEvent } from 'lib/gtm'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles(theme => ({
  buttonBox: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    margin: '16px 0',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  learnMoreButton: {
    marginRight: '16px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '12px',
    },
  },
}))

export default ({
  titleText,
  gtmLearnObject,
  learnMoreLink,
  gtmDoActionObject,
  doActionLink,
  doActionText,
  extraTitleLine,
  doActionLinkExternal,
}) => {
  const history = useHistory()
  const classes = useStyles()
  return (
    <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
      <Typography>{titleText}</Typography>
      {extraTitleLine ? (
        <Box mt={2}>
          <Typography mt={2}>{extraTitleLine}</Typography>
        </Box>
      ) : null}
      <Box className={classes.buttonBox}>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          className={classes.learnMoreButton}
          onClick={() => {
            gtmEvent(gtmLearnObject)
            window.open(learnMoreLink, '_blank')
          }}
        >
          Learn More
        </Button>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => {
            gtmEvent(gtmDoActionObject)
            if (!doActionLinkExternal) {
              history.push(doActionLink)
            } else {
              window.open(doActionLink, '_blank')
            }
          }}
        >
          {doActionText}
        </Button>
      </Box>
    </Box>
  )
}
